import { render, staticRenderFns } from "./econsent.vue?vue&type=template&id=adc2600a&scoped=true&"
import script from "./econsent.vue?vue&type=script&lang=js&"
export * from "./econsent.vue?vue&type=script&lang=js&"
import style0 from "./econsent.vue?vue&type=style&index=0&id=adc2600a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc2600a",
  null
  
)

component.options.__file = "econsent.vue"
export default component.exports